import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { installGlobalImageFallback } from "./utils/imageFallback";
import "./css/reset.css";
import "./css/variables.css";
import "./css/global.css";

installGlobalImageFallback();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
